var render, staticRenderFns
import script from "./ClearWnb.vue?vue&type=script&lang=js&"
export * from "./ClearWnb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06bab2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e06bab2c')) {
      api.createRecord('e06bab2c', component.options)
    } else {
      api.reload('e06bab2c', component.options)
    }
    
  }
}
component.options.__file = "src/components/Settings/ClearWnb.vue"
export default component.exports